import { ApiService } from '@shared/api-utils';
import { getConfig } from '@shared/utils';
import type { LotteryName } from '../../lottery-purchases/types';
import type { LotteryConfig } from '../types';
import { getLotteryConfigPath } from './lotteryConfig';

async function fetchLotteryConfig(lotteryName: LotteryName): Promise<LotteryConfig | null> {
  const { apiUrl, apiLocale } = getConfig();
  const apiService = ApiService.getInstance(apiUrl);
  const { data } = await apiService.get<LotteryConfig>(getLotteryConfigPath(lotteryName, apiLocale));

  return data;
}

export { fetchLotteryConfig };
